import React from "react";
import {inject, observer} from "mobx-react";
import {BannerStore} from "Stores/bannerStore";
import {Utils} from "../../common/utils";
import {AccordionBanner} from "./AccordionBanner";
import {Row, Col} from "react-bootstrap";

interface IWhatsNewSectionProps {
    bannerStore?: BannerStore
}

@inject("bannerStore")
@observer
export class WhatsNewSection extends React.Component<IWhatsNewSectionProps> {

    async componentDidMount() {
        Utils.setViewName("WhatsNewView", "What’s New");
        if (!this.props.bannerStore?.whatsNewBanners) {
            return null;
        }
        this.props.bannerStore.fetchWhatsNewBanners();
    }

    render(): any {
        if (!this.props.bannerStore?.whatsNewBanners) {
            return <div>
                <h1>No news available</h1>
            </div>;
        } else {
            return (
                <div className="whats-new-section-container">
                    <Row>
                        <Col className={"whats-new-title"}>
                            <h3 id="whats-new-title">NEWS</h3>
                        </Col>
                    </Row>
                    <section className="accordions-container">
                        {Object.entries(this.props.bannerStore?.whatsNewBanners).reverse()
                            .map(([year, banners], index) =>
                            (
                                <span key={year}>
                                    <AccordionBanner year={year} banners={banners} key={index} index={index} />
                                </span>
                            ))
                        }
                    </section>
                </div>
            );
        }

    }
}